import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";

const SignUpButton = ({ path }) => (
  <Link
    className="nav-btn"
    to="/signup"
    state={path}
  >
    <span className="btn btn-sm m-1 flex-fill">Sign Up</span>
  </Link>
);

export default connect()(SignUpButton);
